import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col, Badge } from "reactstrap";

import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import TrialRequestModel from './trial-request';
class BlockContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        }
        this.togglemodal.bind(this);
    }

    togglemodal = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    render() {
        return (
            <React.Fragment>
                <Container>
                    <Row className="align-items-center">
                        <Col sm="12" className="mt-4 mt-sm-0">
                            <div className="section-title mb-1 pb-1 text-center" name="maintitle">
                                <CountUp end={1484} duration={1} redraw={true}>
                                    {({ countUpRef, start }) => (
                                        <VisibilitySensor onChange={start} delayedCall>
                                            <span  style={{ fontSize: 60 }} ref={countUpRef} />
                                        </VisibilitySensor>
                                    )}
                                </CountUp>
                                <h5 className="title mb-4" > Traders Using TelegramTradeCopier. Download Now</h5>
                            </div>
                        </Col>
                    </Row>
                    {/* <Row className="align-items-center">
                        <Col sm="12" className="mt-4 mt-sm-0">
                            <div className="text-sm-center">
                                <Link to="#"  id="demoSection-demo-download-btn" onClick={this.togglemodal} className="btn btn-outline-primary">Try Now <Badge color="danger" className="rounded ml-2">v2.0.0</Badge> </Link>
                            </div>
                        </Col>
                    </Row> */}

                </Container>
                <TrialRequestModel modal={this.state.modal} togglemodal={this.togglemodal} ></TrialRequestModel>
            </React.Fragment>
        );
    }
}

export default BlockContainer;